const Overlay = ({ children }) => {
    return (
        <div className="fixed top-0 bottom-0 left-0 right-0 z-30 bg-gray-300 bg-opacity-40 flex items-center justify-center">
            {children}
        </div>
    );
};

export default Overlay;
